import { getAuthToken } from 'utils/token'

const UPLOAD_URL = process.env.UPLOAD_URL ?? ''
const CONVERT_HEIC_URL = process.env.CONVERT_HEIC_URL ?? ''

type UploadFileOptions = {
  // удалить фон
  removeBg?: boolean
}

/**
 * Uploads file to cdn and returns uploaded file url
 *
 *  curl --request POST \
 *  --url https://cdn.epic-2687.test.worldwinelist.com/upload \
 *  --header 'authorization: Bearer {token}' \
 *  --header 'content-type: multipart/form-data' \
 *  --form file=@1x1empty.png
 *
 * @example
 * const handleChange = async (event) => {
 *   const file = event.target.files[0]
 *   const uploadedFileUrl = await uploadFile(file)
 * }
 * <input type="file" onChange={handleChange} />
 */
export const uploadFile = async (
  file: File,
  options?: UploadFileOptions
): Promise<string> => {
  if (!UPLOAD_URL && process.env.NODE_ENV !== 'production') {
    throw new Error('UPLOAD_URL is not set in .env file')
  }

  // // for tests
  // if (process.env.NODE_ENV === 'development') {
  //   await new Promise(resolve => setTimeout(resolve, 3000)) // timeout 3s
  //   return 'https://habrastorage.org/webt/d6/ik/1-/d6ik1-wnutz_s5utrvhmarl-kri.jpeg'
  // }

  const method = 'POST'

  const body = new FormData()
  body.append('file', file)
  if (options?.removeBg) {
    body.append('remove_bg', 'true')
  }

  const headers = {
    Authorization: `Bearer ${getAuthToken()}`,
  }

  const response = await fetch(UPLOAD_URL, {
    method,
    body,
    headers,
  })

  if (response.status !== 200) {
    const errorText =
      response && response.status !== 405
        ? await response.text()
        : 'Error uploading image'
    throw new Error(errorText)
  }

  return response.text()
}

export const heicToPng = async file => {
  if (!CONVERT_HEIC_URL) {
    throw 'CONVERT_HEIC_URL is not set in .env file'
  }
  const body = new FormData()
  body.append('file', file)
  const headers = {
    Authorization: `Bearer ${getAuthToken()}`,
  }

  const response = await fetch(CONVERT_HEIC_URL, {
    method: 'POST',
    body,
    headers,
  })

  if (response.status === 200) {
    const blob = await response.blob()
    const fileNameWithoutExtension = file.name.replace(/\.[^/.]+$/, '')
    return new File([blob], fileNameWithoutExtension + '.png', {
      type: blob.type,
    })

    // return new File([text], 'image.png', {
    //   type: 'image/png',
    // })
  } else {
    throw new Error(
      response && response.status !== 405
        ? await response.text()
        : 'Error uploading image'
    )
  }
}

export const getFileExtension = (filename: string) => {
  const result = filename.substring(
    filename.lastIndexOf('.') + 1,
    filename.length
  )
  return (result || filename).toLowerCase()
}

export const isUnsupportedImageType = (file: File) => {
  return (
    file.type === 'image/heic' ||
    file.type === 'image/heif' ||
    ['heic', 'heif'].includes(getFileExtension(file.name))
  )
}

export default uploadFile
